import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: {},
    token: null,
    notificationPreferences: {
        events: true,
        announcements: true,
        services: true,
        appointments: true,
        devotions: true,
        reminders: true,
        bibleStudy: true,
        socialFeed: true,
    },
};

const auth2Slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = action.payload;
        },
        setToken(state, action) {
            state.token = action.payload;
        },
        setPreferences(state, action) {
            state.notificationPreferences = action.payload;
        },
    },
});

export const { setUser, setToken } = auth2Slice.actions;
export default auth2Slice.reducer;
